export const getModalHeaderMessages = (messages) => ({
    mainHeader: messages.mainHeader,
    subHeader: messages.subHeader,
    searchBar: messages.searchBar,
    warningMessage: messages.onlyOneUserAllowedWarning,
});
export const getAccountsListViewMessages = (messages) => ({
    accountHeader: messages.accountHeader,
    expirationText: messages.expirationText,
    expirationShortText: messages.expirationShortText,
    emptyListHeader: messages.emptyListHeader,
    emptyListDescription: messages.emptyListDescription,
    youText: messages.youText,
});
export const getBottomButtonsMessages = (messages) => ({
    cancelButtonText: messages.cancelButtonText,
    mainButtonText: messages.mainButtonText,
    userSelectionRequiredWarning: messages.userSelectionRequiredWarning,
    enterCodeInputLabel: messages.enterCodeInputLabel,
    activateAnywayButtonText: messages.activateAnywayButtonText,
});
export const getCodeInputBarMessages = (messages) => ({
    buttonLabel: messages.mainButtonText,
    enterCodeInputLabel: messages.enterCodeInputLabel,
    consumerRightsHeader: messages.consumerRightsHeader,
    consumerRightsText: messages.consumerRightsText,
    activateAnywayButtonText: messages.activateAnywayButtonText,
});
